import { useContext, useEffect, useState } from "react"
import UiInput1 from "./ui_input1"
import UiButton1 from "./ui_button1"
import { AppContext } from "./context"
import { apiUrl, live, webAuth } from "./delcare"
import UiSpinner from "./ui_spinner"

const UserAdd = () => {

    const {
        neonUser,
        validateEmail,
        token,
        setReloadList,
        setToastContent,
        toastInit,
        offCanvas,
        fetchDataV2
    } = useContext(AppContext)

    const [user, setUser] = useState({
        email: "",
        fname: "",
        all_entities: true,
        role: "normal"
    })
    const [search, setSearch] = useState("")
    const [entityList, setEntityList] = useState([])
    const [selectedEntities, setSelectedEntities] = useState([])
    const [error, setError] = useState("")
    const [message, setMessage] = useState("")
    const [load, setLoad] = useState(false)
    const [roles, setRoles] = useState(["admin", "normal", "editor"])

    const addUserHandler = async () => {
        setError("")
        setMessage("")
        setLoad(true)

        if (validateEmail(user.email) == null) {
            setError("Email is invalid")
            setLoad(false)
            return
        }

        if ([undefined, null, false, ""].includes(user.role)) {
            setError("Role field must not be empty.")
            setLoad(false)
            return
        }

        let query1 = "CHECK_EMAIL_EXISTS", params1 = [user.email]
        let exists = await fetchDataV2(query1, params1, "/neon-query-v2")

        if (Number(exists[0].exists) > 0) {
            setError("Email is already in use.")
            setLoad(false)
            return
        }

        let metaData = {
            role: user.role,
            entity_id_list: `{${selectedEntities.map(x => x.id).join(", ")}}`,
            fname: user.fname,
            all_entities: user.all_entities ? "TRUE" : "FALSE",
            agency_id: neonUser.agency.agency_id.toString()
        }

        let data = {
            connection: 'Username-Password-Authentication',
            email: user.email,
            password: 'Qwer@1234',
            user_metadata: metaData,
            role: user.role
        }

        await new Promise((resolve, reject) => {
            webAuth.signup(data, function (err) {
                if (err) {
                    setError('Something went wrong: ' + JSON.stringify(err))
                    setLoad(false)
                    resolve()
                    return
                }

                fetch(`${apiUrl}/invite_user_email`, {
                    method: "POST",
                    headers: (() => {
                        let myHeaders = new Headers()
                        myHeaders.append("Content-Type", "application/json")
                        myHeaders.append("Authorization", "Bearer " + token.accessToken)
                        return myHeaders
                    })(),
                    body: JSON.stringify({
                        "live": live,
                        "email_to": user.email,
                        "agency": neonUser?.agency?.agency_name || "An Agency"
                    })
                })

                setMessage("User has been invited.")
                setToastContent("User has been invited.")
                toastInit.show()
                offCanvas.hide()
                setReloadList(true)
                setUser({
                    email: "",
                    fname: "",
                    all_entities: true,
                    role: "normal"
                })
                setLoad(false)
                resolve()
            })
        })

        return
    }

    const changeUserHandler = (value, field) => {
        if (field == 'role' && ["admin", "owner"].includes(value)) {
            setUser({ ...user, all_entities: true, [field]: value })
            return
        }
        setUser({ ...user, [field]: value })
    }

    const addRemoveEntity = (x) => {
        if (selectedEntities.map(xx => xx.id).includes(x.id)) {
            setSelectedEntities([...selectedEntities.filter(xx => xx.id != x.id)])
            return
        }
        else {
            setSelectedEntities([...selectedEntities, x])
            return
        }
    }

    const getEntityList = async () => {
        let query1 = "GET_BRANDS_1", params1 = [neonUser.agency_id]
        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
        setEntityList(resp)
    }

    useEffect(() => {
        if (neonUser.user_id && entityList.length == 0) getEntityList()
    }, [neonUser])

    return (
        <div className="d-flex flex-column justify-content-between h-100">
            <div className="d-flex flex-column gap-3">
                {error && <p className="poppins text-danger">{error}</p>}
                {message && <p className="poppins text-success">{message}</p>}

                <div>
                    <p className="poppins fw-bold mb-1">Email Address</p>
                    <UiInput1 field="email" value={user.email} userChangeHandler={changeUserHandler} />
                </div>

                <div>
                    <p className="poppins fw-bold mb-1">Name</p>
                    <UiInput1 field="fname" value={user.fname} userChangeHandler={changeUserHandler} />
                </div>

                <div>
                    <p className="poppins fw-bold mb-1">Role</p>
                    <div className="d-flex gap-1 dropdown">
                        <div data-bs-toggle="dropdown" aria-expanded="false">
                            <UiInput1 capitalize={true} field="" value={user.role == 'normal' ? "read only" : user.role} userChangeHandler={null} readOnly={true} dropdown={true} />
                        </div>
                        <div className="dropdown-menu">
                            {roles.map(x => (
                                <p key={x} onClick={() => changeUserHandler(x, 'role')} className="poppins dropdown-item mb-1 text-capitalize">
                                    {x == 'normal' ? "Read Only" : <span className="text-capitalize">{x}</span>}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>

                {["normal", "editor"].includes(user.role) && (
                    <div className="d-flex flex-column gap-1">
                        <p className="mb-0 fw-bold poppins">Brand/Account Access</p>
                        <div className="d-flex gap-3">
                            <input type="radio" name="selected" className="input-radio align-self-center" onChange={(e) => changeUserHandler(true, 'all_entities')} checked={user.all_entities} />
                            <span className="poppins align-self-center">All</span>
                            <input type="radio" name="selected" className="input-radio align-self-center" onChange={(e) => changeUserHandler(false, 'all_entities')} checked={!user.all_entities} />
                            <span className="poppins align-self-center">Selected</span>
                        </div>
                    </div>
                )}

                {!user.all_entities && (
                    <div>
                        <p className="poppins fw-bold mb-1">Brands/Accounts</p>
                        <div className="d-flex gap-1 dropup-center">
                            <div className="w-75" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                <UiInput1 dropdown={true} readOnly={true} value={(selectedEntities.length || 'No') + (selectedEntities.length > 1 ? " Brands/Accounts" : " Brand/Account")} userChangeHandler={null} />
                            </div>
                            <ul className="dropdown-menu">
                                <div className="px-2">
                                    <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} className="form-control form-control-sm mb-1 poppins" placeholder="search..." />
                                </div>
                                <li className="px-2 d-flex flex-column gap-1" style={{ maxHeight: 200, overflowY: 'auto' }}>
                                    {entityList.filter(x => x.brand.toLowerCase().includes(search.toLowerCase())).map(x => (
                                        <div key={x.id} style={{ maxWidth: 200, cursor: "pointer" }} className="d-flex gap-2" onClick={() => addRemoveEntity(x)}>
                                            {selectedEntities.map(xx => xx.id).includes(x.id) ?
                                                <i className="bi bi-check-square"></i>
                                                :
                                                <i className="bi bi-square"></i>
                                            }
                                            <p className="poppins text-truncate mb-0" title={x.brand}>{x.brand}</p>
                                        </div>
                                    ))}
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
            </div>

            {load ?
                <UiSpinner />
                :
                <div>
                    <UiButton1 text="Add User" submit={addUserHandler} />
                </div>
            }
        </div>
    )
}

export default UserAdd